module.exports = __webpack_public_path__ + "img/002徐向南.a495c008.jpg";